const errorMessages = {
	default: 'عملیات با خطا مواجه شد.',
	403: 'لطفا برای دسترسی به پنل پذیرندگان، فیلترشکن خود را خاموش نمایید.',
	TIMEOUT: 'مشکلی پیش آمد. لطفاً دوباره تلاش کنید.',
	NETWORK: 'اتصال اینترنت را بررسی کنید.',
};

export default errorMessages;
